export default __webpack_public_path__ + "static/media/sistemab2.9ea1c1e4.jpg";